import React from 'react';
import Slider from 'react-slick';
import './BusImages.css';
import '../../styles/slick.css';
import '../../styles/slick-theme.css';

const BusImages = ({ busImagesUrl, isMobileDevice }) => {
  const SampleNextArrow = props => {
    const { className, onClick } = props;
    return (
      <div className={className} style={{ display: 'flex' }} onClick={onClick}>
        {!isMobileDevice && <button></button>}
      </div>
    );
  };

  const SamplePrevArrow = props => {
    const { className, onClick } = props;
    return (
      <div className={className} style={{ display: 'flex' }} onClick={onClick}>
        {!isMobileDevice && <button></button>}
      </div>
    );
  };

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    className: 'busImgSlickCarousel',
    slidesToShow: 3.7,
    swipeToSlide: true,
    slidesToScroll: 1,
    adaptiveHeight: true,
    variableWidth: false,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3.7,
          slidesToScroll: 2,
          infinite: false,
          dots: false
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2.8,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 650,
        settings: {
          slidesToShow: 2.4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 620,
        settings: {
          slidesToShow: 2.3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 450,
        settings: {
          slidesToShow: 1.7,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 400,
        settings: {
          slidesToShow: 1.4,
          slidesToScroll: 1
        }
      }
    ]
  };
  return (
    <div className="busImages makeRelative">
      <Slider {...settings}>
        {busImagesUrl.map((imageUrl, idx) => (
          <div className="busImagesCard" key={'busImage_' + idx}>
            <img
              // style={{ objectFit: "cover" }}
              className="lazyload"
              data-src={imageUrl}
              alt="busImg"
            />
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default BusImages;
